// extracted by mini-css-extract-plugin
export var dropdown = "_sc-0";
export var imageWrapper = "_sc-3";
export var itemNameContainer = "_sc-1";
export var productImage = "_sc-2";
export var spinnerWrapper = "_sc-4";